// This file is auto-generated. Do not edit manually.

import { z } from "zod";

export const FileSystemTags = z.enum([
  "admin",
  "user",
  "document",
  "appraisal",
  "initialAssessment",
  "inspectorUploads",
]);
export type FileSystemTagsEnums = z.infer<typeof FileSystemTags>;

export const FileResponseSchema = z.object({
  id: z.number(),
  originalName: z.string(),
  fileName: z.string(),
  filePath: z.string(),
  mimeType: z.string(),
  size: z.number(),
  systemFileTag: FileSystemTags,
  createdAt: z.date(),
  signedUrl: z.string().url(),
  urlExpiresAt: z.date(),
  previewFilePath: z.string().nullable().optional(),
  previewSignedUrl: z.string().url().nullable().optional(),
  previewUrlExpiresAt: z.date().nullable().optional(),
  category: z.string().nullable().optional(),
  isExternalUpload: z.boolean().optional(), // To indicate if the file was uploaded via an external link
  duplicatedFromRequestId: z.string().nullable().optional(), // Tracks files copied from another request during duplication
});
export type FileResponse = z.infer<typeof FileResponseSchema>;

export const UploadedFileSchema = z.object({
  originalName: z.string(),
  fileName: z.string(),
  filePath: z.string(),
  mimeType: z.string(),
  size: z.number(),
  systemFileTag: FileSystemTags,
  previewFilePath: z.string().nullable().optional(),
  formFieldName: z.string().optional(), // To track which form field this file is associated with, e.g., "frontViewPhoto"
  category: z.string().nullable().optional(),
  isExternalUpload: z.boolean().optional(), // To indicate if the file was uploaded via an external link
});
export type UploadedFile = z.infer<typeof UploadedFileSchema>;

export const FileSchema = FileResponseSchema.omit({
  signedUrl: true,
  urlExpiresAt: true,
}).extend({
  requestId: z.string(),
  updatedAt: z.date(),
});
export type File = z.infer<typeof FileSchema>;
